// extracted by mini-css-extract-plugin
module.exports = {"blockstyle":"style_blockstyle__35V2v"};